// extracted by mini-css-extract-plugin
export var root = "_100-0";
export var scroll = "_100-1";
export var thumb = "_100-3";
export var track = "_100-2";